// src/features/counterSlice.ts
import { createSlice } from '@reduxjs/toolkit';

export interface GlobalLoadingState {
  isSettingsLoading: boolean;
  isLoading: boolean;
}

const initialState: GlobalLoadingState = {
  isLoading: false,
  isSettingsLoading: false,
};

const globalLoadingSlice = createSlice({
  name: 'globalLoading',
  initialState,
  reducers: {
    setIsSettingsLoading: (state, action: { payload: boolean }) => {
      state.isSettingsLoading = action.payload;
    },
    setIsLoading: (state, action: { payload: boolean }) => {
      state.isLoading = action.payload;
    },
  },
});

export const { setIsSettingsLoading, setIsLoading } =
  globalLoadingSlice.actions;
export default globalLoadingSlice.reducer;
